import React from 'react';
import { Box, Skeleton, Paper } from '@mui/material';

/**
 * Generic page-loading skeleton — a title bar, a row of stat tiles and a table
 * shell. Used by AppLayout as the route-transition placeholder so navigating to
 * any screen shows structure immediately instead of a blank pane.
 */
const PageSkeleton: React.FC<{ tiles?: number; rows?: number }> = ({ tiles = 4, rows = 6 }) => (
  <Box>
    {/* Header */}
    <Box sx={{ mb: 3 }}>
      <Skeleton variant="text" width={280} height={40} />
      <Skeleton variant="text" width={420} height={20} />
    </Box>

    {/* Stat tiles */}
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: `repeat(${Math.min(tiles, 4)}, 1fr)` },
        gap: 2,
        mb: 3,
      }}
    >
      {Array.from({ length: tiles }).map((_, i) => (
        <Paper key={i} elevation={0} sx={{ p: 2, borderRadius: 3, border: '1px solid', borderColor: 'divider' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Skeleton variant="circular" width={42} height={42} />
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="70%" height={26} />
              <Skeleton variant="text" width="45%" height={16} />
            </Box>
          </Box>
        </Paper>
      ))}
    </Box>

    {/* Table shell */}
    <Paper elevation={0} sx={{ borderRadius: 3, border: '1px solid', borderColor: 'divider', p: 2 }}>
      <Skeleton variant="rectangular" height={36} sx={{ borderRadius: 1, mb: 1 }} />
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} variant="text" height={30} sx={{ my: 0.5 }} />
      ))}
    </Paper>
  </Box>
);

export default PageSkeleton;
